import React, { useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { DragIndicator, ArrowDropUp, ArrowDropDown } from "@material-ui/icons";

import Grid, { GridSpacing } from "@material-ui/core/Grid";
import "./test.css";

export default function Test() {
  const [items, setItems] = React.useState([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
  ]);

  const [yPos, setYpos] = useState(0);

  const onClick = (direction) => {
    direction === "up" ? setYpos((x) => x + 100) : setYpos((x) => x - 100);
  };

  const onSortEnd = (oldIndex, newIndex) => {
    setItems((array) => arrayMove(array, oldIndex, newIndex));
  };

  return (
    <SortableList
      onSortEnd={onSortEnd}
      onSortStart={(_, event) => event.preventDefault()}
      distance={1}
      className="list"
      draggedItemClassName="dragged"
    >
      {items.map((item) => (
        <SortableItem key={item}>
          <Grid container spacing={3}>
            <Grid item xs={2} style={{ maxWidth: "10px" }}>
              <ArrowDropUp />
              <DragIndicator style={{ cursor: "grab" }} />
              <ArrowDropDown />
            </Grid>
            <Grid item xs={10}>
              <div className="item">{item}</div>
            </Grid>
          </Grid>
        </SortableItem>
      ))}
    </SortableList>
  );
}
